import React from 'react';
import PropTypes from 'prop-types';
import { CommonDialogs } from "../../constants/Dialogs";

import { Card, CardText } from 'material-ui/Card';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import EventIcon from 'material-ui/svg-icons/action/event';
import SecurityIcon from 'material-ui/svg-icons/hardware/security';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import DetailView from '../Common/DetailView';
import Gravatar from 'react-gravatar';
import buildContextMenu from '../Common/BuildContextMenu';
import ConfirmDialog from "../Common/ConfirmDialog";
import ErrorSnackbar from "../Common/ErrorSnackbar";
import SuccessSnackbar from "../Common/SuccessSnackbar";
import { formatName } from '../../utils/StringUtils';

import UserActions from "../../actions/UserActionCreator";
import DialogActions from "../../actions/DialogActionCreator";


const getActions = (user) => [
    {
        link: '/dashboard/profile/edit',
        icon: <EditIcon />,
        label: 'Edit profile',
    },
    {
        action: () => DialogActions.open(CommonDialogs.CONFIRM),
        icon: <SecurityIcon />,
        label: 'Change password',
    },
    {
        link: `/dashboard/user/${user.id}/calendar`,
        icon: <EventIcon />,
        label: 'Calendar',
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    }
];


const style = {
    avatar: {
        borderRadius: '50%'
    },
};

const Profile = (props, {auth}) => {
    const user = auth.getCurrentUser();
    return (
        <DetailView
            title='Profile'
            backButton={true}
            actions={buildContextMenu(getActions(user))}
        >
            <div className="cent-cards">
                <Card className="cent-card">
                    <CardText>
                        <Gravatar
                            email={user.email}
                            default='https://cdn.premierit.com/images/icons/contact.png'
                            size={100}
                            style={style.avatar}
                        />
                    </CardText>
                    <CardText>
                        <div className='cent-flex-row'>
                            <div className='cent-col-2'>
                                <ul className="cent-list-plain">
                                    <li><em>Name: </em>{formatName(user)}</li>
                                    <li><em>Username: </em>{user.username}</li>
                                    <li><em>Email: </em>{user.email}</li>
                                    <li><em>Organisation: </em>{user.organisation.name}</li>
                                    <li><em>Job role: </em>{user.jobRole}</li>
                                </ul>
                            </div>
                            <div className='cent-col-2'>
                                <p>{user.biog}</p>
                            </div>
                        </div>
                    </CardText>
                </Card>
            </div>
            <ConfirmDialog
                title="Change password"
                message={(
                    <div>
                        <p>Request password reset email?</p>
                        <p>To reset your password, we'll send you a recovery link.
                            Please check your email and follow the instructions to set a new password.</p>
                    </div>
                )}
                confirmButtonLabel="Send"
                onConfirm={() => UserActions.passwordReset({username: user.email})}
            />
            <ErrorSnackbar/>
            <SuccessSnackbar message="Request sent"/>
        </DetailView>
    );
};



Profile.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Profile;
